import { Component, ViewChild, OnInit } from '@angular/core';
import { TipoOperacionDialogBoxComponent } from './dialog/dialog-box.component';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { TipoOperacionService } from '../../../services/tipo-operacion.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { TipoOperacion } from 'app/main/models/tipo-operacion.model';

const ELEMENT_DATA: TipoOperacion[] = [];

@Component({
    selector   : 'tipo-operacion',
    templateUrl: './tipo-operacion.component.html',
    styleUrls  : ['./tipo-operacion.component.scss']
})
export class TipoOperacionComponent
{
    displayedColumns: string[] = ['nombre', 'tipoSujetoObligado', 'factorDeRiesgo', 'action'];
    dataSource = ELEMENT_DATA;
    isAdmin = false;
    basicSlice = 10;
    elementCount = 0;

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    

    constructor(public dialog: MatDialog,
        private _snackBar: MatSnackBar,
        private tokenStorage: TokenStorageService,
        private service: TipoOperacionService) {}

    ngOnInit() {

      this.paginator._intl.itemsPerPageLabel="Ítems por página";
      var role = this.tokenStorage.getRole();
      for(var i=0;i<role.length;i++){
        //Admin o Especialista en riesgos
        if(role[i]==2 || role[i]==5)
          this.isAdmin = true;
      }

      this.service.count().subscribe(req => {
        this.elementCount = req.body;
      });
      this.getPaginator(0);

      
    }

    getPaginator(page): void{

      this.service.getAll(page,this.basicSlice).pipe().subscribe(req => {
        this.dataSource = req.body.map( tipo => {
          console.log(tipo);
          return {
            id: tipo.id,
            nombre: tipo.nombre,
              tipoSujetoObligado: tipo.tipoSujetoObligado,
              factorDeRiesgo: tipo.factorDeRiesgo,
            bloqueado: tipo.bloqueado
          };
        });
      });
    }

    openDialog(action, obj): void {
      obj.action = action;
      const dialogRef = this.dialog.open(TipoOperacionDialogBoxComponent, {
        width: '100%',
        data: obj
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'Add' || result.event === 'Duplicate'){
          this.addRowData(result.data);
        } else if (result.event === 'Update') {
          this.updateRowData(result.data);
        } else if (result.event === 'Delete') {
          this.deleteRowData(result.data);
        }
      });
    }

    addRowData(row_obj): void {
      console.log('Im here');
      row_obj.id = null;
      this.service.register(row_obj).pipe(first()).subscribe(
        tipo => {
          console.log(tipo);
          this.dataSource.push({
            id: tipo.body.id,
            nombre: tipo.body.nombre,
            tipoSujetoObligado: tipo.body.tipoSujetoObligado,
              factorDeRiesgo: tipo.body.factorDeRiesgo,
            bloqueado: tipo.body.bloqueado
          });

          this.openSnackBar("Se ingresó el tipo de operación correctamente.","Cerrar");
          this.dataSource.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
          this.table.renderRows();
        },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo ingresar el tipo de operación, ocurrió un error.","Cerrar");
        }
      );
    }

    updateRowData(row_obj): void {
      this.service.edit(row_obj.id, row_obj).pipe(first()).subscribe(
        data => {
          console.log(data);
          this.dataSource = this.dataSource.filter((value, key) => {
            if (value.id === row_obj.id) {
                value.id = row_obj.id;
                value.nombre = row_obj.nombre;
                value.tipoSujetoObligado = row_obj.tipoSujetoObligado;
                value.factorDeRiesgo = row_obj.factorDeRiesgo;
                value.bloqueado = row_obj.bloqueado;
            }
            return true;
          });
          this.openSnackBar("Se actualizó el tipo de operación correctamente.","Cerrar");
        },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo actualizar el tipo de operación, ocurrió un error.","Cerrar");
        }
      );
    }

    deleteRowData(row_obj): void {
      this.service.delete(row_obj.id).pipe(first()).subscribe(
        data => {
          console.log(data);
          this.dataSource = this.dataSource.filter((value, key) => {
            return value.id !== row_obj.id;
          });
          this.openSnackBar("Se elimino el tipo de operación correctamente.","Cerrar");
        },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo eliminar el tipo de operación, esta asociado a otra entidad.","Cerrar");
        }
      );
    }


    OnePageChange(event: PageEvent) {
      this.basicSlice = event.pageSize;
      this.getPaginator(event.pageIndex);
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }



}
